import React from 'react';

import Card from "@mui/joy/Card";
import Chip from "@mui/joy/Chip";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import CardContent from "@mui/joy/CardContent";
import {Stack} from "@mui/joy";

// components
import RouteDetail from "../Route/RouteDetail";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import retrievePermission from "../../utils/retrievePermission";
import RouteControlledEntityModal from "../Route/RouteControlledEntityModal";


class RouteCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            dcePermission: 0,
        };
    }

    async componentDidMount(){
        await this.retrieveDcePermission();
    }

    async retrieveDcePermission() {
        let p = await retrievePermission(
            'RouteControlledEntityViewSet',
            'create',
            this.context.subscriberObject
        )
        await this.setState(
            {
                dcePermission: p,
            }
        )
    }

    render() {
        return (
            <Card
                variant={'plain'}
                size={'sm'}
            >
                <CardContent>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={2}
                            flexWrap={'nowrap'}
                        >
                            <Chip
                                color={'primary'}
                                sx={{mr: 2}}
                            >
                                {this.props.route.entity_human}
                            </Chip>
                            <Typography
                                level={'body2'}
                                sx={{mr: 2, display: 'inline-flex'}}
                            >
                                {this.props.route.title}
                            </Typography>
                            <Chip
                                sx={{mr: 2}}
                                color={this.props.route.states[0].stage.color}
                            >
                                {this.props.route.states[0].stage.title}
                            </Chip>
                            {
                                this.props.route.completed?
                                    <Chip
                                        sx={{mr: 2}}
                                        color={'success'}
                                    >
                                        Завершен
                                    </Chip>:
                                    <Stack
                                        direction={'row'}
                                        alignItems="center"
                                        spacing={1}
                                        flexWrap={'nowrap'}
                                    >
                                        <Chip
                                            color={this.props.route.states[0].delay[1]?'success':'danger'}
                                        >
                                            {this.props.route.states[0].delay[0]}
                                        </Chip>
                                        <Typography level={'body-sm'} sx={{mb: 1}}>из</Typography>
                                        <Chip
                                            color={'primary'}
                                        >
                                            {this.props.route.states[0].stage.end_delay}
                                        </Chip>
                                    </Stack>
                            }

                        </Stack>

                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                            flexWrap={'nowrap'}
                        >
                            {this.state.dcePermission > 0?
                                <RouteControlledEntityModal
                                    route={this.props.route}
                                />:
                                null
                            }
                            <RouteDetail
                                route={this.props.route}
                                callBack={this.props.callBack}
                            />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        )
    }
}

export default RouteCard